const legal = {
  infoPageLayout: {
    manageCookies: "Gestisci i miei cookie",
  },
  terms: {
    title: "Condizioni d'uso",
    subtitle: "Regole generali applicabili all'accesso e all'utilizzo di Qubiq.",
    sections: [
      {
        title: "1. Oggetto",
        body: "{{brandName}} è una piattaforma interattiva di streaming video che permette di guardare contenuti, interagire con giochi integrati e usare funzionalità della community.",
      },
      {
        title: "2. Accesso al servizio",
        body: "L'accesso ad alcune funzioni di Qubiq richiede la creazione di un account. L'utente si impegna a fornire informazioni corrette, a mantenere riservati i propri accessi e a non utilizzare il servizio in modo improprio.",
      },
      {
        title: "3. Contenuti e comportamenti vietati",
        body: "È vietato pubblicare, diffondere o rilanciare contenuti illeciti, fraudolenti, d'odio, violenti, ingannevoli, pornografici non autorizzati, lesivi dei diritti di terzi o contrari alle regole di moderazione di Qubiq.",
      },
      {
        title: "4. Proprietà intellettuale",
        body: "Gli elementi della piattaforma Qubiq, il suo design, i suoi marchi, i suoi contenuti visivi, le sue interfacce e i suoi sviluppi restano protetti. Salvo autorizzazione espressa, non possono essere copiati, riprodotti, estratti o riutilizzati a fini commerciali.",
      },
      {
        title: "5. Sospensione o eliminazione dell'account",
        body: "Qubiq può limitare, sospendere o eliminare l'accesso a tutto o parte del servizio in caso di mancato rispetto di queste condizioni, tentativo di frode, comportamento dannoso per la community o rischio per la sicurezza.",
      },
      {
        title: "6. Contatto",
        body: "Per qualsiasi domanda su queste condizioni, puoi scrivere a {{contactEmail}}.",
      },
    ],
  },
  privacy: {
    title: "Informativa sulla privacy",
    subtitle: "Come Qubiq tratta i dati personali e come esercitare i tuoi diritti.",
    sections: [
      {
        title: "Titolare del trattamento",
        body: "{{companyName}}, accessibile tramite {{websiteUrl}}, agisce come titolare del trattamento per i dati trattati nell'ambito della piattaforma {{brandName}}.",
      },
      {
        title: "Dati trattati",
        body: "A seconda dell'uso del servizio, possiamo trattare: identità dell'account, email, nome utente, immagine del profilo, cronologia d'uso, interazioni della community, preferenze di consenso, informazioni tecniche di navigazione e dati collegati al wallet o ai guadagni quando queste funzioni vengono utilizzate.",
      },
      {
        title: "Finalità e basi giuridiche",
        body: "- Fornire il servizio, la riproduzione video, i giochi, il profilo e le notifiche: esecuzione del servizio.\n- Proteggere la piattaforma, contrastare le frodi e moderare i contenuti: interesse legittimo e obblighi di legge.\n- Gestire richieste di supporto e diritti GDPR: obbligo di legge e interesse legittimo.\n- Misurare l'audience con Google Analytics: consenso.",
      },
      {
        title: "Destinatari",
        body: "I dati sono accessibili, secondo necessità, ai team autorizzati di Qubiq e ai suoi fornitori tecnici. Qubiq utilizza in particolare Clerk per l'autenticazione e Google Analytics per la misurazione dell'audience quando lo accetti.",
      },
      {
        title: "Tempi di conservazione",
        body: "I tempi variano in base alla finalità:\n- account utente: per tutta la durata dell'account e poi secondo gli obblighi di legge applicabili;\n- log tecnici e di sicurezza: per il periodo limitato necessario alla sicurezza e alla diagnosi;\n- preferenze cookie: 6 mesi;\n- dati di audience: secondo la configurazione di Google Analytics e la politica di conservazione scelta da Qubiq.",
      },
      {
        title: "Trasferimenti fuori dall'UE",
        body: "Alcuni fornitori possono trattare dati al di fuori dell'Unione europea. In tal caso, Qubiq adotta le garanzie adeguate richieste dal GDPR, incluse clausole contrattuali appropriate quando necessarie.",
      },
      {
        title: "I tuoi diritti",
        body: "A seconda dei casi, hai diritto di accesso, rettifica, cancellazione, opposizione, limitazione, portabilità e di revocare in qualsiasi momento il consenso per i trattamenti basati su di esso. Puoi inoltre presentare un reclamo alla CNIL.",
      },
      {
        title: "Contatto dati personali",
        body: "Per qualsiasi richiesta relativa ai tuoi dati personali: {{privacyEmail}}.",
      },
    ],
  },
  legalNotice: {
    title: "Note legali",
    subtitle: "Informazioni sull'editore del servizio e sull'hosting del sito.",
    items: {
      editorLabel: "Editore del sito",
      legalFormLabel: "Forma giuridica",
      legalFormValue: "{{legalForm}} — capitale sociale: {{capital}}",
      registrationLabel: "Registrazione",
      registrationValue: "Registro delle imprese di {{registrationCity}} {{registrationNumber}}",
      registrationDateLabel: "Data di registrazione",
      euidLabel: "EUID",
      vatLabel: "Numero IVA intracomunitario",
      addressLabel: "Indirizzo",
      activitiesLabel: "Attività principali",
      publicationDirectorLabel: "Direttore della pubblicazione",
      contactLabel: "Contatto",
      hostingLabel: "Hosting",
      hostingValue: "{{hostingCompany}}\n{{hostingAddress}}",
      intellectualPropertyLabel: "Proprietà intellettuale",
      intellectualPropertyValue:
        "I contenuti, le interfacce, i marchi, gli elementi visivi e gli sviluppi del servizio Qubiq sono protetti. Qualsiasi riproduzione o sfruttamento non autorizzato è vietato.",
    },
  },
  cookies: {
    title: "Cookie policy",
    subtitle: "Informazioni sui tracciatori utilizzati da Qubiq e sulla gestione delle tue scelte.",
    sections: [
      {
        title: "Principio",
        body: "Qubiq utilizza cookie e altri tracciatori necessari al funzionamento del servizio. I tracciatori di misurazione dell'audience sono disattivati per impostazione predefinita e vengono attivati solo dopo il tuo consenso esplicito.",
      },
      {
        title: "Categorie utilizzate",
        body: "- Cookie necessari: sicurezza, accesso, stabilità della sessione, funzionamento essenziale.\n- Misurazione dell'audience: Google Analytics 4, con consenso.\n- Marketing: al momento non attivato su Qubiq.",
      },
      {
        title: "Durata e terze parti",
        body: "- Preferenza di consenso Qubiq: memorizzata localmente con la chiave {{consentStorageKey}} per 6 mesi.\n- {{analyticsProvider}}: cookie di misurazione dell'audience, durata predefinita annunciata da Google: fino a 2 anni, soggetta alle limitazioni del browser e alla configurazione scelta da Qubiq.\n- Fornitore terzo coinvolto nella misurazione dell'audience: Google.",
      },
      {
        title: "Google Analytics",
        body: "{{analyticsProvider}} non viene caricato prima del tuo consenso. Quando lo accetti, Qubiq utilizza la misurazione dell'audience per comprendere meglio l'uso del servizio, migliorare le prestazioni e identificare le principali tendenze di navigazione.",
      },
      {
        title: "Revocare o modificare il consenso",
        body: "Puoi modificare le tue scelte in qualsiasi momento dal pulsante “Gestisci i miei cookie” disponibile in questa pagina, nei link informativi del sito e nel menu profilo.",
      },
      {
        title: "Promemoria normativo",
        body: "Su Qubiq, rifiutare i cookie di misurazione dell'audience è semplice quanto accettarli. Il servizio principale resta accessibile anche senza attivare Google Analytics.",
      },
    ],
  },
  moderation: {
    title: "Regole di moderazione di Qubiq",
    subtitle: "Le regole della Qubiq Republic per proteggere la community, i creator e i giocatori.",
    sections: [
      {
        title: "1. Rispetto della community",
        body: "Non sono consentiti insulti, attacchi mirati, umiliazioni, minacce, campagne di molestie o comportamenti destinati a nuocere a un altro utente, creator o moderatore.",
      },
      {
        title: "2. Contenuti illegali o pericolosi",
        body: "Sono vietati: apologia di reati, terrorismo, contenuti pedocriminali, doxxing, diffusione non autorizzata di dati personali, truffe, frodi, hacking, incitamento all'odio o qualsiasi pubblicazione contraria alla legge.",
      },
      {
        title: "3. Inganno, spam e manipolazione",
        body: "È vietato fare spam, manipolare artificialmente l'audience, pubblicare falsi concorsi o ingannare gli utenti su premi, giochi, qubs o condizioni di partecipazione.",
      },
      {
        title: "4. Protezione dei minori",
        body: "Sono vietati contenuti sessualizzati, scioccanti, umilianti o pericolosi per i minori. Gli utenti devono evitare qualsiasi messa in scena inappropriata o sfruttamento di pubblici vulnerabili.",
      },
      {
        title: "5. Giochi e fair play",
        body: "Qualsiasi tentativo di barare, automazione abusiva, aggiramento delle regole di run, duplicazione di guadagni, sfruttamento di bug o alterazione volontaria dell'esperienza di gioco può comportare la sospensione o l'eliminazione dell'account.",
      },
      {
        title: "6. Diritti di terzi",
        body: "Devi disporre dei diritti necessari per pubblicare contenuti su Qubiq. Violazioni di copyright, diritti d'immagine, privacy o marchi di terzi possono portare a una moderazione immediata.",
      },
      {
        title: "7. Misure possibili",
        body: "Qubiq può rimuovere un contenuto, limitare alcune funzionalità, bloccare una condivisione, sospendere un account, revocare vantaggi legati alla piattaforma o segnalare i fatti alle autorità quando la situazione lo giustifica.",
      },
      {
        title: "8. Spirito Qubiq",
        body: "Qubiq è una piattaforma interattiva: si può discutere, giocare, esibirsi e condividere. Ma l'esperienza deve restare sana, leale, chiara e rispettosa. Se un contenuto rompe questo equilibrio, può essere moderato.",
      },
    ],
  },
};

export default legal;
